module.exports = __webpack_public_path__ + "img/HeroBG.2e1de6d9.png";